require('normalize.css/normalize.css');
require('styles/App.css');
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Event from './Event'
import EventInvite from './EventInvite'
import 'react-datepicker/dist/react-datepicker.css';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

export default class Calendar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      startDate: moment(),
	  startEvent: <Event />,
	  ExampleCustomInput: <EventInvite />,
	};
    this.handleChange = this.handleChange.bind(this);
	 this.handleSelect = this.handleSelect.bind(this);
	  this.onClick = this.onClick.bind(this);
  }

  handleSelect(date) {
    this.setState({
      startDate: date
    });
  }
  handleChange (date) {
  this.setState({startDate: date})
  //this.toggleCalendar()
}

toggleCalendar (e) {
  e && e.preventDefault()
    this.setState({isOpen: this.state.isOpen})

//this.setState({startEvent: this.state.ExampleCustomInput})
}
  handleClick () {
  this.setState({startEvent: this.state.startEvent})
}

  render() {
    return (
	
  <div>
 
    <button
        className='invite'
        onClick={this.state.ExampleCustomInput}>
       {this.state.startDate.format('DD-MM-YYYY')}
    </button>
    {
       this.state.isOpen &&
		(
            <DatePicker
    inline
                selected={this.state.startDate}
                onChange={this.handleChange}
				onClick={this.handleClick}
                withPortal
                ></DatePicker>
				)
    }
</div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/Calendar.js